import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Popup, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {toUpperCase} from '../../../common/util/fieldsNormalization';

const INITIAL_STATE = {
  'isOpen': false,
  'code': '',
};

class SubstituteModal extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
    this.handleOpenClick = this.handleOpenClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  renderTrigger() {
    const {isReplacement} = this.props;
    const title = isReplacement ? 'Sustitutos' : 'Compatibles';

    return (
      <Popup inverted
        content={`Opciones de ${title}`}
        trigger={
          <Button circular floated='right' className='add-button' color='blue' size='tiny'
            icon='settings' onClick={this.handleOpenClick} />
        }
      />
    );
  }

  handleOpenClick(event) {
    event.preventDefault();
    this.setState({'isOpen': true, 'code': ''});
  }

  handleSaveClick() {
    const {code} = this.state;
    const {partCode, isReplacement, savePartSubstitute, savePartEquivalence} = this.props;
    const saveFunction = isReplacement ? savePartSubstitute : savePartEquivalence;

    if (code) {
      saveFunction(partCode, {code});
      this.closeModal();
    }
  }

  handleDeleteClick() {
    const {code} = this.state;
    const {partCode, isReplacement, deletePartSubstitute, deletePartEquivalence} = this.props;
    const deleteFunction = isReplacement ? deletePartSubstitute : deletePartEquivalence;

    if (code) {
      deleteFunction(partCode, code);
      this.closeModal();
    }
  }

  closeModal() {
    this.setState({'isOpen': false});
  }

  handleChange(event, data) {
    this.setState({'code': toUpperCase(data.value)});
  }

  render() {
    const {isReplacement} = this.props;
    const {code} = this.state;
    const title = isReplacement ? 'Sustituto' : 'Compatible';

    return (
      <Modal
        size='small'
        className='parts-master'
        open={this.state.isOpen}
        trigger={this.renderTrigger()}
      >
        <Modal.Header>{`Opciones de Repuesto ${title}`}</Modal.Header>
        <Modal.Content>
          <label>
            <strong>Código del Repuesto {title}</strong>
          </label>
          <Input
            fluid
            value={code}
            error={!code}
            onChange={this.handleChange}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            inverted
            color='red'
            disabled={!code}
            onClick={this.handleDeleteClick}
          >
            Eliminar
          </Button>
          <Button secondary onClick={this.closeModal}>
            Cancelar
          </Button>
          <Button primary disabled={!code} onClick={this.handleSaveClick}>
            Guardar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const {values} = state.partsMaster;

  return {'partCode': values.partCode};
};

const {
  savePartEquivalence,
  savePartSubstitute,
  deletePartEquivalence,
  deletePartSubstitute,
} = Actions;

export default connect(mapStateToProps, {
  savePartEquivalence,
  savePartSubstitute,
  deletePartEquivalence,
  deletePartSubstitute,
})(SubstituteModal);
